const GoogleMaps = require('./../../../../../global/js/modules/google-maps'),
    VueUtils = require('../../../modules/vue-utils');

function _confirm(message, okLabel = 'OK', cancelLabel = 'CANCEL', preConfirmCallback = null) {
    let $dialog = VueUtils.getRef('modal-dialog');
    $dialog.setPreConfirmCallback(preConfirmCallback);
    $dialog.showCancel();
    $dialog.setCancelLabel(cancelLabel);
    $dialog.setOkLabel(okLabel);
    return $dialog.setContent(message, true);
}

function _maybeSetupMaps() {
    let $mapElements = document.querySelectorAll('.page-block-container.my-bookings .location-map'),
        $coordinateElement = null
    ;

    if (!$mapElements) {
        return;
    }

    let markers = [];

    for (let $element of $mapElements) {
        $coordinateElement = $element.querySelector('script[type="text/gps-coordinates"]');

        if (!$coordinateElement) {
            $element.remove();
            continue;
        }

        const coordinate = JSON.parse($coordinateElement.innerText);

        if (!coordinate) {
            return;
        }

        GoogleMaps.insertMap($element, {
            center: coordinate,
            zoom: 17
        }).then((map) => {
            $coordinateElement._marker = new google.maps.Marker({
                position: coordinate,
                map: map
            });

            $coordinateElement._marker.setMap(map);
            markers.push($coordinateElement._marker);
        });

    }
}

function _setCancelLinkEvent($link) {
    $link.addEventListener('click', event => {
        event.stopImmediatePropagation();
        event.preventDefault();

        _confirm('Are you sure you wish to cancel this booking?', 'YES', 'NO')
            .then(() => {
                document.location = $link.getAttribute('href');
            }, () => {

            });

        return false;
    });
}

function _setQueryDatesEvent($button) {
    $button.addEventListener('click', event => {
        event.stopImmediatePropagation();
        event.preventDefault();

        const $rebookFields = $button.parentNode.querySelector('.rebook-date-selector');
        const $alert = $rebookFields.querySelector('p.alert');

        _confirm($rebookFields, 'OK', 'CANCEL', () => {
            $alert.classList.add('d-none');
            for (let $field of $rebookFields.querySelectorAll('input[type=text]')) {
                if ($field.value.trim() === '') {
                    $alert.classList.remove('d-none');
                    return false;
                }
            }
            return true;
        })
            .then(() => {
                window.setTimeout(() => {
                    $button.disabled = true;
                    $button.parentNode.submit();
                }, 100)
            }, () => {});

        return false;
    });
}

function _setupCancelButtons() {
    const $cancelLinks = document.querySelectorAll('#layout-content a.cancel-booking');

    if ($cancelLinks.length === 0) {
        return;
    }

    for (let $link of $cancelLinks) {
        _setCancelLinkEvent($link);
    }
}

function _setupRebookButtons() {
    const $buttons = document.querySelectorAll('form.rebook-form input[type=submit');

    if ($buttons.length === 0) {
        return;
    }

    for (let $button of $buttons) {
        _setQueryDatesEvent($button);
    }
}

document.addEventListener('DOMContentLoaded', () => {

    if (!document.querySelector('html.my-account.my-bookings')) {
        return;
    }

    _maybeSetupMaps();
    _setupCancelButtons();
    _setupRebookButtons();

});